import Big from 'big.js';

export const scaleProductFor50L = product => {
  if (product.volume === 50) {
    return product;
  }

  const multiplier = new Big(50).div(product.volume);
  const alteredProduct = Object.assign({}, product);
  alteredProduct.volume = 50;
  alteredProduct.ingredients = alteredProduct.ingredients.map(i => {
    return {
      ...i,
      amount: new Big(i.amount).times(multiplier).toFixed(2)
    };
  });

  return alteredProduct;
};



// WEBPACK FOOTER //
// ./src/utils/products.js